import ILocation from "../interfaces/ILocation";
import useFocusShape from "./useFocusShape";
import useLocationsInsideShape from "./useLocationsInsideShape";

export default function (locations: ILocation[]): ILocation[] {
    return useLocationsInsideShape(locations, useFocusShape());
}
